<template>
  <div class="card shadow-sm border-0 rounded-4 h-100">
    <div class="card-body p-3">
      <div class="d-flex justify-content-between flex-column align-items-start mb-1">
        <h6 class="text-uppercase text-muted fs-6 mb-0">Historial Crediticio</h6>
        <span class="badge rounded-pill px-3 py-1" :class="badgeClass">{{ label }}</span>
      </div>

      <small class="text-muted">Puntaje Equifax: {{ equifaxScore != null ? equifaxScore : "—" }}</small>
      <h4 class="fw-bold fs-4 mt-1">{{ points.toFixed(1) }}</h4>
      <small class="text-muted">Rango: {{ bandText }}</small>
    </div>
  </div>
</template>

<script>
export default {
  name: "CreditHistoryCard",
  props: {
    // Puntaje crudo de Equifax (1–999)
    equifaxScore: { type: Number, default: null },
    // v-model:points (aporte a score total 0–15)
    points: { type: Number, default: 0 }
  },
  emits: ["update:points"],
  computed: {
    // Mapea Equifax a 0–15 usando bandas + regla de 3 dentro de cada banda
    computedPoints() {
      const s = Number(this.equifaxScore);
      if (!Number.isFinite(s)) return 0;

      // Bandas Equifax -> NUEVOS rangos de salida (0–15)
      if (s >= 925 && s <= 999) return this.mapRange(s, 925, 999, 13, 15);
      if (s >= 861 && s <= 924) return this.mapRange(s, 861, 924, 10, 12);
      if (s >= 538 && s <= 860) return this.mapRange(s, 538, 860, 7, 9);
      if (s >= 117 && s <= 537) return this.mapRange(s, 117, 537, 4, 6);
      if (s >= 1   && s <= 116) return this.mapRange(s, 1, 116, 0, 3);

      if (s > 999) return 15; // tope superior
      return 0;               // sin dato o fuera de rango inferior
    },
    bandText() {
      const s = Number(this.equifaxScore);
      if (!Number.isFinite(s)) return "—";
      if (s >= 925 && s <= 999) return "925–999 → 13–15";
      if (s >= 861 && s <= 924) return "861–924 → 10–12";
      if (s >= 538 && s <= 860) return "538–860 → 7–9";
      if (s >= 117 && s <= 537) return "117–537 → 4–6";
      if (s >= 1   && s <= 116) return "1–116 → 0–3";
      return "Fuera de rango";
    },
    // Clasificación textual según la NUEVA escala 0–15
    label() {
      const p = this.computedPoints;
      if (p >= 13) return "Excelente";
      if (p >= 10) return "Bueno";
      if (p >= 7)  return "Riego Medio";
      if (p >= 4)  return "Riesgo Alto";
      return "Alto muy Alto";
    },
    badgeClass() {
      const p = this.computedPoints;
      if (p >= 13) return "bg-success-subtle text-success-emphasis";
      if (p >= 10) return "bg-success-subtle text-success-emphasis";
      if (p >= 7)  return "bg-warning-subtle text-warning-emphasis";
      if (p >= 4)  return "bg-warning-subtle text-warning-emphasis";
      return "bg-danger-subtle text-danger-emphasis";
    }
  },
  watch: {
    computedPoints: {
      immediate: true,
      handler(val) {
        // Sincroniza v-model:points con 0–15
        this.$emit("update:points", Number(val.toFixed(1)));
      }
    }
  },
  methods: {
    mapRange(x, inMin, inMax, outMin, outMax) {
      const ratio = (x - inMin) / ((inMax - inMin) || 1);
      return outMin + ratio * (outMax - outMin);
    }
  }
};
</script>

<style scoped>
/* Helpers por si tu build no trae subtle/emphasis */
.bg-success-subtle { background-color: rgba(25,135,84,.12) !important; }
.text-success-emphasis { color: #146c43 !important; }
.bg-warning-subtle { background-color: rgba(255,193,7,.15) !important; }
.text-warning-emphasis { color: #997404 !important; }
.bg-danger-subtle { background-color: rgba(220,53,69,.12) !important; }
.text-danger-emphasis { color: #842029 !important; }
</style>
